import { Footer as DefaultFooter, FooterProps } from '@actr/widgets/src/components/_misc/layouts/footer';
import React, { FC, memo } from 'react';

const Footer: FC<FooterProps> = props => (
  <DefaultFooter {...props} />
);

export default memo(Footer);
